import React, { useState } from "react";

import Modal from "../modal";
import Hamburger from "hamburger-react";
import p from "../../assets/alphabets/p_white.svg";

const Header = () => {
  const options = ["Home", "Works", "Skills", "Timeline", "Contact"];
  const [toggle, setToggle] = useState(false);
  const handleClick = (e, item) => {
    e.stopPropagation(); // Prevent the event from bubbling up
    setToggle(false)
    const targetElement = document.getElementById(item); // Get the element by ID
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" }); // Smooth scrolling to the element
    }
  };
  return (
    <>
      <Modal isOpen={toggle}>{
        options.map((item,index) => { 
          return (<p key={index} style={{ fontSize: 42, fontWeight: 700 ,textAlign:'center',cursor:'pointer'}} onClick={(e)=>handleClick(e,item)} >
            {item}
          </p>)
        })
      }</Modal>
      <header className="header">
        <div>
          <img  src={p}  alt="logo" />
        </div>
        <div style={{ zIndex: 15 }}>
          <Hamburger
            size={30}
            label={"show menu"}
            distance="sm"
            rounded
            direction="left"
            onToggle={(toggle) => {
              setToggle(toggle);
            }}
            toggled={toggle}
          />
        </div>
      </header>
    </>
  );
};

export default Header;
